/* eslint-disable react-hooks/exhaustive-deps */
import { Visibility, VisibilityOff } from "@mui/icons-material";
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Autocomplete,
  Box,
  Card,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import Button from "components/Button/button";
import CurrencyList from "components/CurrencyList/currencyList";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import ShowProfile from "components/ShowProfileModal/ShowProfileModal";
import ViewDocument from "components/ViewDocumentModal/viewDocument";
import CustomText from "components/customtext/customtext";
import SignatureModel from "components/signatureModel/signatureModel";
import { useMaterialUIController } from "context";
import "cropperjs/dist/cropper.css";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import getCroppedImg from "layouts/profile/editMyProfile/cropImage";
import { useCallback, useEffect, useState } from "react";
import Cropper from "react-easy-crop";
import { useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import Swal from 'sweetalert2';
import { fetchDefaultSettings, updateDefaultSettingData } from "utils/api";
import { appConstants } from "utils/appConstants";
import { showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import { useNavigate } from "react-router-dom";
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

const cropContainer = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: "80px",
};

const style = {
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  bgcolor: 'background.paper',
  boxShadow: 24,
  // p: 4,
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
};

let fetchedDefault;
let SCREEN_RIGHT;
let myfile;


function DefaultSetting() {
  const [controller] = useMaterialUIController();
  const navigate = useNavigate();
  const { sidenavColor } = controller;
  const [invoicePrefixErr, setInvoicePrefixErr] = useState(false);
  const [invoiceStartNumberErr, setInvoiceStartNumberErr] = useState(false);
  const [quotationPrefixErr, setQuotationPrefixErr] = useState(false);
  const [quotationStartNumberErr, setQuotationStartNumberErr] = useState(false);
  const [rctiPrefixErr, setRctiPrefixErr] = useState(false);
  const [rctiStartNumberErr, setRctiStartNumberErr] = useState(false);
  const [credPrefixErr, setCredPrefixErr] = useState(false);
  const [credStartNumberErr, setCredStartNumberErr] = useState(false);
  const [currencyValueErr, setCurrencyValueErr] = useState(false);
  const [hideEyeBtn, setHideEyeBtn] = useState(false);
  const [hideEyeBtnLogo, setHideEyeBtnLogo] = useState(false);
  const [showUploadedFileFlag, setShowUploadedFileFlag] = useState(false);
  const [showSignatureDialogeFlag, setShowSignatureDialogeFlag] = useState(false);

  //-------UPLOAD LOGO -----------------
  const [dynamicAspect, setDynamicAspect] = useState(1 / 1);
  const [file, setFile] = useState("");
  const [actualFile, setActualFile] = useState("");
  const [logoFileName, setLogoFileName] = useState("");
  const [showEYEBtn, setShowEYEBtn] = useState(false);
  const [showImageFlag, setShowImageFlag] = useState(false);
  const [fileName, setFileName] = useState("");

  const dispatch = useDispatch();

  const [values, setValues] = useState({
    invoicePrefix: "",
    invoiceStartNumber: "",
    creditNotePrefix: "",
    creditNoteStartNumber: "",
    quotationPrefix: "",
    quotationStartNumber: "",
    rctiPrefix: "",
    rctiStartNumber: "",
    currencyValue: "",
    SignatureFilePath: "",
    defaultLogoFileName: "",
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID,

  });

  const { tableBorder } = getColorMappings(sidenavColor);

  const handleChange = (name) => (event) => {
    let value = event.target.value;

    if (name === "quotationPrefix" || name === "creditNotePrefix" || name === "invoicePrefix" || name === "rctiPrefix") {
      setValues({ ...values, [name]: value.toUpperCase() });
    } else if (event.target.validity.valid || event.target.validity === undefined) {
      setValues({ ...values, [name]: value });
    }
  };

  const deleteDocument = async () => {

    // setShowSignatureDialogeFlag(true);
    setHideEyeBtn(false);
    setFileName("");
    setValues({ ...values, signatureFilePath: "" });
    await axios.post(appConstants.baseURL + 'defaultSettings/deleteBusinessUserSignature', { businessUserID: values.businessUserID }).then((res) => {
      if (res.data.Result_Status) {
        swal('Deleted', res.data.Result_Message, "success")
        setFileName("");
        setHideEyeBtn(false);
      } else {
        // swal('Error', res.data.Result_Message, "error")
      }
    }).catch(err => {
      console.log("deleteDocument", err)
    })
  };

  const deleteDocumentLogo = async () => {

    // setShowSignatureDialogeFlag(true);
    setHideEyeBtnLogo(false);
    setLogoFileName("");
    setValues({ ...values, defaultLogoFileName: "" });
    await axios.post(appConstants.baseURL + 'defaultSettings/deleteBusinessUserLogo', { businessUserID: values.businessUserID }).then((res) => {
      if (res.data.Result_Status) {
        swal('Deleted', res.data.Result_Message, "success")
        setLogoFileName("");
        setOpenCropImageModal(false);
      } else {
        // swal('Error', res.data.Result_Message, "error")
      }
    }).catch(err => {
      console.log("deleteDocument", err)
    })
  };

  const handleCancel = () => () => {
    setShowSignatureDialogeFlag(false);
    setShowUploadedFileFlag(false);
    setShowImageFlag(false);
  };

  const handleSignature = async (val) => {
    try {
      let formData = new FormData();
      formData.append("imageData", val);
      formData.append("businessUserID", values.businessUserID);
      await axios.post(appConstants.baseURL + 'defaultSettings/UpdateBusinessUserSignature', formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
          },
        }
      )
        .then(res => {
          if (res.data.Result_Status) {
            Swal.fire({
              title: "Success",
              text: res.data.Result_Message,
              showCancelButton: false,
              confirmButtonText: "Ok",
              icon: "success",
              customClass: { confirmButton: 'okbutton' }
            });
            setShowSignatureDialogeFlag(false);
            setHideEyeBtn(true);
            setFileName(res.data.Result_Output.signatureFilePath);
            setValues({ ...values, signatureFilePath: res.data.Result_Output.signatureFilePath });
          } else {
            setHideEyeBtn(false);
            swal("Danger", res.data.Result_Message, "warning");
          }
        });
    } catch (error) {
      console.error('Error in handleSignature:', error.message);
    }
  };

  const [openCropImageModal, setOpenCropImageModal] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const saveCropedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(file, croppedAreaPixels);
      setFile(croppedImage);
      myfile = await fetch(croppedImage)
        .then((r) => r.blob())
        .then((blobFile) => new File([blobFile], actualFile.name, { type: "image/*" }));
      setActualFile(myfile);
      if (showSignatureDialogeFlag) {
        setFileName(actualFile.name);
      } else {
        setLogoFileName(actualFile.name);
      }

      setOpenCropImageModal(false);
      setZoom(1);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels]);

  const handleCropCancel = async () => {
    setOpenCropImageModal(false)
    setFile();
    setActualFile();
    setFileName('');
    setLogoFileName('');

    setShowEYEBtn(false)
    setDynamicAspect(1 / 1);
  };
  const saveFile = (e) => {
    try {
      const fileInput = e.target;
      const file = fileInput.files[0];
      if (file) {
        let fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > 1) {
          showResMsg(`File can't be blank or more than 1 MB`, 2000, false);
        } else {
          setOpenCropImageModal(true);
          setFile(URL.createObjectURL(file));
          setActualFile(file);
          if (showSignatureDialogeFlag) {
            setFileName(file.name);
          }
          setLogoFileName(file.name);
          setHideEyeBtnLogo(true);

          const reader = new FileReader();
          reader.onloadend = () => {
            setShowImageFlag(false);
            setShowEYEBtn(true);
          };
          reader.readAsDataURL(file);
        }
      } else {
        // Handle the case when no file is selected
        setFile(null);
        setActualFile(null);
        setFileName('');

        setShowEYEBtn(false);
      }
      // Reset the file input value to allow re-selection of the same file
      fileInput.value = null;
    } catch (error) {
      console.log("Catch in saveFile=", error);
    }
  };



  useEffect(() => {
    loadData();
  }, [dispatch])

  const loadData = () => {
    fetchDefaultSettings({ businessUserID: values.businessUserID }, (data) => {
      if (data.Result_Output) {
        fetchedDefault = data.Result_Output;
        setValues(fetchedDefault);
        values.defaultLogoFileName = fetchedDefault.defaultLogoFileName;
        if (values.defaultLogoFileName) {
          setHideEyeBtnLogo(true);
          setLogoFileName(fetchedDefault.defaultLogoFileName);
          setFile(appConstants.baseURL + "employee/viewFile?fileName=" + values.defaultLogoFileName);
        }
        setValues(fetchedDefault);
        if (fetchedDefault.signatureFilePath) {
          setHideEyeBtn(true)
          setFileName(fetchedDefault.signatureFilePath);
        }
      }
    }, dispatch)
  }
  const clearErrorStates = () => {
    setInvoicePrefixErr(false);
    setInvoiceStartNumberErr(false);
    setQuotationPrefixErr(false);
    setQuotationStartNumberErr(false);
    setRctiPrefixErr(false);
    setRctiStartNumberErr(false);
    setCredPrefixErr(false);
    setCredStartNumberErr(false);
    setCurrencyValueErr(false);
  };

  const handleAddData = async () => {
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag = validateField(values.invoicePrefix, setInvoicePrefixErr) || mandateFlag;
    mandateFlag = validateField(values.invoiceStartNumber, setInvoiceStartNumberErr) || mandateFlag;
    mandateFlag = validateField(values.quotationPrefix, setQuotationPrefixErr) || mandateFlag;
    mandateFlag = validateField(values.quotationStartNumber, setQuotationStartNumberErr) || mandateFlag;
    mandateFlag = validateField(values.rctiPrefix, setRctiPrefixErr) || mandateFlag;
    mandateFlag = validateField(values.rctiStartNumber, setRctiStartNumberErr) || mandateFlag;
    mandateFlag = validateField(values.creditNotePrefix, setCredPrefixErr) || mandateFlag;
    mandateFlag = validateField(values.creditNoteStartNumber, setCredStartNumberErr) || mandateFlag;
    mandateFlag = validateField(values.currencyValue, setCurrencyValueErr) || mandateFlag;
    if (mandateFlag) return;
    const formData = new FormData();
    const arrayOfObjects = Object.entries(values).map(([key, value]) => ({ key, value }));
    for (const val of arrayOfObjects) {
      if (val.value) {
        formData.append(val.key, val.value);
      }
    }
    if (actualFile) {
      formData.append('file', actualFile);
      formData.append('fileName', logoFileName);
    }
    updateDefaultSettingData(formData, (data) => {
      // showResMsg(data.Result_Status ? genericMessage.updated : data.Result_Message, 3000, data.Result_Status);
      // loadData();
      showResMsg(data.Result_Status ? genericMessage.updated : data.Result_Message, 3000, data.Result_Status, navigate, `/dashboard`);

    }, dispatch);
  };

  const handleClose = () => {
    navigate(`/dashboard`);
  };

  const handleNewChange = (name) => (event, newValue) => {
    if (newValue) {
      setValues({ ...values, [name]: newValue.label, currencyValue: newValue.value });
    }

  };
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox mt={3} mb={3}>
        <Grid container spacing={1} style={{ display: "flex", justifyContent: "center" }}>
          <Grid item lg={12} xs={12}>
            <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">Default Settings</MDTypography>
              </MDBox>
              <Grid container px={2} py={2} spacing={3}>
                <Grid item lg={6} sm={12}>
                  <Box>
                    <Grid container spacing={3}>
                      <Grid item lg={12} mb={-2} mt={-1}>
                        <CustomText type="b" color="white">
                          Quotation Settings
                        </CustomText>
                      </Grid>
                      <Grid item lg={6} md={6} xs={12}>
                        <TextField
                          type="text"
                          label="Quotation Number Prefix"
                          variant="outlined"
                          fullWidth
                          inputProps={{
                            maxLength: 5,
                            pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                            className: "custom-fieldtext"
                          }}
                          value={values.quotationPrefix}
                          onChange={handleChange("quotationPrefix")}
                          autoFocus={true}
                        />
                        {quotationPrefixErr ? <span style={errMsg}>Quotation Number Prefix can't be blank</span> : ""}
                      </Grid>
                      <Grid item lg={6} md={6} xs={12}>
                        <TextField
                          type="text"
                          label="Quotation Start Number "
                          variant="outlined"
                          fullWidth
                          inputProps={{
                            pattern: "^[0-9]+$",
                            maxLength: 5,
                            className: "custom-fieldtext"
                          }}
                          value={values.quotationStartNumber}
                          onChange={handleChange("quotationStartNumber")}
                        />
                        {quotationStartNumberErr ? <span style={errMsg}>Quotation Start Number can't be blank</span> : ""}
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item lg={6} sm={12}>
                  <Box>
                    <Grid container spacing={3}>
                      <Grid item lg={12} mb={-2} mt={-1}>
                        <CustomText type="b" color="white">
                          Invoice Settings
                        </CustomText>
                      </Grid>
                      <Grid item lg={6} md={6} xs={12}><TextField
                        type="text"
                        label="Invoice Number Prefix"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 5,
                          pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                          className: "custom-fieldtext"
                        }}
                        value={values.invoicePrefix}
                        onChange={handleChange("invoicePrefix")}
                      />
                        {invoicePrefixErr ? <span style={errMsg}>Invoice Number Prefix can't be blank</span> : ""}</Grid>
                      <Grid item lg={6} md={6} xs={12}>
                        <TextField
                          type="text"
                          label="Invoice Start Number"
                          variant="outlined"
                          fullWidth
                          inputProps={{
                            pattern: "^[0-9]+$",
                            maxLength: 5,
                            className: "custom-fieldtext"
                          }}
                          value={values.invoiceStartNumber}
                          onChange={handleChange("invoiceStartNumber")}
                        />
                        {invoiceStartNumberErr ? <span style={errMsg}>Invoice Start Number can't be blank</span> : ""}
                      </Grid>

                    </Grid>
                  </Box>
                </Grid>
                <Grid item lg={6} sm={12}>
                  <Box>
                    <Grid container spacing={3}>
                      <Grid item lg={12} mb={-2} mt={-1}>
                        <CustomText type="b" color="white">
                          RCTI Settings
                        </CustomText>
                      </Grid>
                      <Grid item lg={6} md={6} xs={12}><TextField
                        type="text"
                        label="RCTI Number Prefix"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 5,
                          pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                          className: "custom-fieldtext"
                        }}
                        value={values.rctiPrefix}
                        onChange={handleChange("rctiPrefix")}
                        autoFocus={true}
                      />
                        {rctiPrefixErr ? <span style={errMsg}>RCTI Number Prefix can't be blank</span> : ""}</Grid>
                      <Grid item lg={6} md={6} xs={12}>
                        <TextField
                          type="text"
                          label="RCTI Start Number "
                          variant="outlined"
                          fullWidth
                          inputProps={{
                            pattern: "^[0-9]+$",
                            maxLength: 5,
                            className: "custom-fieldtext"
                          }}
                          value={values.rctiStartNumber}
                          onChange={handleChange("rctiStartNumber")}
                        />
                        {rctiStartNumberErr ? <span style={errMsg}>RCTI Start Number can't be blank</span> : ""}
                      </Grid>

                    </Grid>
                  </Box>
                </Grid>
                <Grid item lg={6} sm={12}>
                  <Box>
                    <Grid container spacing={3}>
                      <Grid item lg={12} mb={-2} mt={-1}>
                        <CustomText type="b" color="white">
                          Credit Note Settings
                        </CustomText>
                      </Grid>
                      <Grid item lg={6} md={6} xs={12}><TextField
                        type="text"
                        label="Credit Note Number Prefix"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          maxLength: 5,
                          pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                          className: "custom-fieldtext"
                        }}
                        value={values.creditNotePrefix}
                        onChange={handleChange("creditNotePrefix")}
                        autoFocus={true}
                      />
                        {credPrefixErr ? <span style={errMsg}>credit Note Prefix can't be blank</span> : ""}</Grid>
                      <Grid item lg={6} md={6} xs={12}>
                        <TextField
                          type="text"
                          label="Credit Start Number "
                          variant="outlined"
                          fullWidth
                          inputProps={{
                            pattern: "^[0-9]+$",
                            maxLength: 5,
                            className: "custom-fieldtext"
                          }}
                          value={values.creditNoteStartNumber}
                          onChange={handleChange("creditNoteStartNumber")}
                        />
                        {credStartNumberErr ? <span style={errMsg}>credit Note Start Number can't be blank</span> : ""}
                      </Grid>

                    </Grid>
                  </Box>
                </Grid>
                <Grid item lg={12} sm={12}>
                  <Box>
                    <Grid container spacing={3}>
                      <Grid item lg={12} mb={-2} mt={-1}>
                        <CustomText type="b" color="white">
                          Configuration Settings
                        </CustomText>
                      </Grid>
                      <Grid item lg={12} md={6} xs={12}>
                        <Autocomplete
                          sx={{ height: "35.11px" }}
                          labelId="currencyValue-select-label"

                          id="currencyValue-select"
                          options={CurrencyList.map(currency => ({
                            label: currency.CountryName + "  " + currency.Code + " (" + currency.Symbol + ")",
                            value: currency.Symbol
                          }))}
                          onChange={handleNewChange("currencyValue")}
                          value={values.currencyValue}
                          renderInput={(params) => <TextField {...params} className="ress" label={`Currency ${values.currencyValue}`} autoFocus={true} sx={{ paddingBottom: '6px' }} />}
                        />
                        {currencyValueErr ? <span style={errMsg}>Currency can't be blank</span> : ""}
                      </Grid>
                      <Grid item lg={6} md={6} xs={12}>
                        <label htmlFor="fileInput">
                          <TextField
                            type="text"
                            label="Upload Signature"
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            fullWidth
                            value={fileName}
                            InputProps={{
                              readOnly: true,
                              className: "uploadfile",
                              endAdornment: (
                                <InputAdornment position="end" style={{ marginRight: "-8px" }}>
                                  <label>
                                    <Button
                                      // variant="contained"
                                      // color="dark"
                                      style={{ color: `${tableBorder}`, }}
                                      component="span"
                                      size="small"
                                      allign="right"
                                      onClick={() => { setShowSignatureDialogeFlag(true) }}
                                    >
                                      Click to Sign
                                    </Button>
                                  </label>
                                  <IconButton style={{ marginRight: '-4px', marginLeft: '6px', }}>
                                    {hideEyeBtn ?
                                      <Visibility fontSize="medium" color="info" onClick={() => { setShowUploadedFileFlag(true) }} />
                                      :
                                      <VisibilityOff fontSize="medium" color="grey" />}
                                  </IconButton>

                                  <IconButton onClick={deleteDocument} style={{ marginRight: '0px' }} >
                                    <DeleteIcon fontSize="small" color="error" />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </label>
                      </Grid>
                      <Grid item lg={6} md={6} xs={12}>
                        <label htmlFor="fileInput">
                          <TextField
                            type="text"
                            label="Upload Business Logo"
                            variant="outlined"
                            fullWidth
                            value={logoFileName}
                            InputProps={{
                              readOnly: true,
                              className: "uploadfile",
                              endAdornment: (
                                <InputAdornment position="end" style={{ marginRight: "-12px" }} >
                                  <label className="ress" htmlFor="fileInput">
                                    <Button
                                      component="span"
                                      size="small"
                                      allign="right"
                                      style={{ color: `${tableBorder}`, }}
                                    >
                                      Choose Logo
                                    </Button>
                                  </label>
                                  <IconButton style={{ marginLeft: "-12px" }}>
                                    {hideEyeBtnLogo ?
                                      <Visibility fontSize="medium" color="info" onClick={() => { setShowImageFlag(true); }} />
                                      :
                                      <VisibilityOff fontSize="medium" color="grey" />
                                    }
                                  </IconButton>
                                  <IconButton onClick={deleteDocumentLogo} style={{ marginRight: '-2px' }} >
                                    <DeleteIcon fontSize="small" color="error" />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <input
                            type="file"
                            accept="image/*"
                            id="fileInput"
                            style={{ display: "none" }}
                            onChange={saveFile}
                          />
                        </label></Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>


              <Grid
                container
                py={3}
                columnSpacing={4}
                alignItems="center"
                display="flex"
                justifyContent="center"
              >
                <Grid item xs={12} md={4} spacing={2} lg={1.8}>

                  <MDButton
                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                    color="warning"
                    fullWidth
                    onClick={handleClose}
                  >
                    Close
                  </MDButton>

                </Grid>
                <Grid item xs={12} md={4} spacing={2} lg={1.8}>
                  <MDButton
                    rel="noreferrer"
                    variant="gradient"
                    color="success"
                    fullWidth
                    onClick={handleAddData}
                    disabled={SCREEN_RIGHT === "View Only"}
                  >
                    Save
                  </MDButton>
                </Grid>

              </Grid>
            </Card>
          </Grid>
        </Grid>
      </MDBox>


      <ViewDocument
        open={showUploadedFileFlag}
        fileName={`${appConstants.baseURL}defaultSettings/viewUploadedBusinessUserDocument?fileName=/${fileName}`}
        closeModalClick={handleCancel('closeModalClick')}
      />
      {showSignatureDialogeFlag &&
        <SignatureModel
          open={showSignatureDialogeFlag}
          sign={handleSignature}
          handleCancel={handleCancel('handleCancel')}
          closeModalClick={handleCancel('closeModalClick')}
          titleMsg="Do you want to Submit the Signature?" />}

      <ShowProfile
        open={showImageFlag}
        fileName={file}
        closeModalClick={handleCancel('closeModalClick')}
      />
      <Modal
        open={openCropImageModal}
        onClose={() => { handleCropCancel() }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={style}
      >
        <Grid className="crop-image-wrapper" id="modal-modal-title" >
          <Grid container spacing={2} style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <Grid style={cropContainer}>
              <Cropper
                image={file}
                crop={crop}
                zoom={zoom}
                aspect={dynamicAspect}
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
              />
            </Grid>
            <Grid container spacing={2} className="crop-control" >
              <Grid item  >
                <Typography type="label" style={{ color: "white", fontSize: "12px" }}>
                  Aspect Ratio
                </Typography>{" "}
                <div style={{ display: "flex", justifyContent: 'center', }}>
                  <select onChange={e => { return setDynamicAspect(parseFloat(e.target.value)); }}  >
                    <option>1/1</option>
                    <option value={'1.23'}>1.23/1</option>
                    <option value={'1.33'}>1.33/1</option>
                    <option value={'1.43'}>1.43/1</option>
                    <option value={'1.625'}>1.66/1</option>
                    <option value={'4.136/2'}>4/2</option>
                    <option value={'1.7'}>16/9</option>
                  </select>
                </div>
              </Grid>
              <Grid item >
                <Typography type="label" style={{ color: "white", textAlign: "center", fontSize: "12px" }}>
                  Zoom
                </Typography>&nbsp;
                <input
                  type="range"
                  value={zoom}
                  min={1}
                  max={11}
                  step={0.1}
                  aria-labelledby="Zoom"
                  onChange={(e) => {
                    setZoom(e.target.value)
                  }}
                />
              </Grid>
              <Grid item>
                <Button className="modalButton cropimgbtn" onClick={saveCropedImage}>
                  Crop
                </Button>
              </Grid>
              <Grid item style={{ cursor: "pointer", marginRight: "14px", }}>
                <Button className="modalButton crop-closebtn" onClick={handleCropCancel}>
                  Close
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
    </DashboardLayout >
  );
}

export default DefaultSetting;
